import { Controller, type Control } from "react-hook-form";

import { Input } from "@/components/ui/input";

import { RepresentativeFormField } from "../RepresentativeFormField";
import type { RepresentativeFieldErrorGetter, RepresentativeFormValues } from "../../types";

interface RepresentativeNameFieldsProps {
  control: Control<RepresentativeFormValues>;
  firstNameLabel: string;
  lastNameLabel: string;
  getFieldError: RepresentativeFieldErrorGetter;
}

export const RepresentativeNameFields = ({
  control,
  firstNameLabel,
  lastNameLabel,
  getFieldError,
}: RepresentativeNameFieldsProps) => (
  <div className="grid gap-5 md:grid-cols-2">
    <Controller
      control={control}
      name="first_name"
      render={({ field }) => {
        const errorMessage = getFieldError("first_name");

        return (
          <RepresentativeFormField
            id="first_name-input"
            label={firstNameLabel}
            errorMessage={errorMessage}
            required
          >
            <Input
              {...field}
              id="first_name-input"
              value={field.value ?? ""}
              aria-invalid={!!errorMessage}
              aria-describedby={errorMessage ? "first_name-input-error" : undefined}
              className="border-border"
            />
          </RepresentativeFormField>
        );
      }}
    />

    <Controller
      control={control}
      name="last_name"
      render={({ field }) => {
        const errorMessage = getFieldError("last_name");

        return (
          <RepresentativeFormField
            id="last_name-input"
            label={lastNameLabel}
            errorMessage={errorMessage}
            required
          >
            <Input
              {...field}
              id="last_name-input"
              value={field.value ?? ""}
              aria-invalid={!!errorMessage}
              aria-describedby={errorMessage ? "last_name-input-error" : undefined}
              className="border-border"
            />
          </RepresentativeFormField>
        );
      }}
    />
  </div>
);
